import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import { fadeUp, viewportOnce } from "../../utils/motion";

export const Section = styled.section`
  position: relative;
  padding: 120px 24px;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 84px 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const HeadWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => ($align === "center" ? "center" : "flex-start")};
  text-align: ${({ $align }) => ($align === "center" ? "center" : "left")};
  margin: 0 auto 56px;
  max-width: 640px;
`;

const Eyebrow = styled(motion.span)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 100px;
  background: rgba(139, 124, 255, 0.08);
  border: 1px solid rgba(139, 124, 255, 0.25);
  color: ${({ theme }) => theme.primary};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 18px;
`;

const Title = styled(motion.h2)`
  font-family: "Space Grotesk", sans-serif;
  font-weight: 600;
  font-size: clamp(1.9rem, 4vw, 2.75rem);
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.15;
`;

const Subtitle = styled(motion.p)`
  margin-top: 16px;
  font-size: 16px;
  line-height: 1.7;
  color: ${({ theme }) => theme.text_secondary};
`;

export const SectionHead = ({ eyebrow, title, subtitle, align = "left" }) => (
  <HeadWrap $align={align}>
    {eyebrow && (
      <Eyebrow variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} custom={0}>
        {eyebrow}
      </Eyebrow>
    )}
    <Title variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} custom={1}>
      {title}
    </Title>
    {subtitle && (
      <Subtitle variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} custom={2}>
        {subtitle}
      </Subtitle>
    )}
  </HeadWrap>
);

export default SectionHead;
